<template>
  <v-container id="create_edit_ingredient" fluid tag="section">
    <base-v-component :heading="id ? $t('evaluation-edit') : $t('evaluation-create')" />

    <template>
      <v-card class="mx-auto px-8">
        <v-form>
          <v-container v-if="isLoading">
            <v-row>
              <v-col>
                <v-progress-linear
                  :active="isLoading"
                  :indeterminate="true"
                  height="4"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="!isLoading">
            <v-row>
              <v-col cols="12" md="5">
                <v-text-field v-model="editingObject.inciName" label="INCI Name" />
              </v-col>
              <v-col cols="12" md="5">
                <!--
                <v-text-field 
                  v-if="ingredient" 
                  :value="ingredient.inciName" 
                  label="Connected to ingredient"
                  autocomplete="off"
                  :loading="ingredient.inciName ? false : true"
                />
                -->
                <v-autocomplete
                  v-model="cosingItem"
                  :search-input.sync="searchCosing"
                  :loading="searchCosingLoading"
                  :items="searchCosingItems"
                  item-text="inciName"
                  item-value="cosingRef"
                  hide-no-data
                  hide-selected
                  hide-details
                  return-object
                  :label="cosingRefSuggestion ? 'Suggested ingredient connection' : 'Connected to ingredient'"
                  :class="cosingRefSuggestion ? 'orange-label' : ''"
                >
                  <template slot="item" slot-scope="data">
                    <v-icon small color="red" class="mr-2" v-if="!data.item.evaluationId">mdi-exclamation-thick</v-icon>
                    {{ data.item.inciName }} ({{data.item.casNumber}})
                  </template>
                </v-autocomplete>
                <!--
                 <v-btn
                  v-if="cosingItem.reference"
                  text
                  @click="onIngredientLink"
                >
                  <v-icon right dark>mdi-arrow-top-right</v-icon>
                </v-btn>
                -->
              </v-col>
              <v-col cols="12" md="2" class="text-right pt-6">
                 <v-tooltip v-if="isProhibited()" bottom>
                  <template #activator="{ on }">
                    <v-icon v-on="on" class="mr-2" color="red">mdi-alert</v-icon>
                  </template>
                  <span>Ingredient is prohibited (Annex 2)</span>
                </v-tooltip>
                <v-tooltip v-if="isRestricted()" bottom>
                  <template #activator="{ on }">
                    <v-icon v-on="on" class="mr-2">mdi-alert-circle-outline</v-icon>
                  </template>
                  <span>Ingredient has restriction (Annex 3)</span>
                </v-tooltip>
                <v-btn
                  v-if="cosingLink"
                  text
                  :href="cosingLink"
                  target="_blank"
                >
                  Cosing
                  <v-icon right dark>mdi-arrow-top-right</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editingObject.innName" label="INN Name" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field 
                  v-model="editingObject.casNumber" 
                  :disabled="!isCreate"
                  label="CAS number" 
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="editingObject.ecNumber" label="EC number" />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="editingObject.noael" label="NOAEL (mg/kg bw/day)" />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editingObject.dermalAbsorptionPcnt"
                  label="Dermal Absorption (%)"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editingObject.clp"
                  label="CLP"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  rows="10"
                  v-model="editingObject.assessment"
                  label="Assessment"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea outlined rows="10" v-model="editingObject.function" label="Function" />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  rows="10"
                  v-model="editingObject.iupacName"
                  label="IUPAC Name"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  readonly
                  outlined
                  rows="10"
                  v-model="editingObject.restriction"
                  label="Restriction (read-only)"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  rows="10"
                  v-model="editingObject.evaluatedRestriction"
                  label="Evaluated Restriction"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </template>

    <!-- DIALOG CONFIRM DELETE -->
    <v-dialog v-model="dialogConfirmDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete-project-ingredient') }}</v-card-title>
        <v-card-text>{{ $t('delete-project-ingredient-confirm') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogConfirmDelete = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="error" text @click="deleteItem">{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row 
      v-if="!isLoading"
      align="center" 
      justify="center" 
      class="mt-8"
    >
      <v-btn
        v-if="id"
        color="error"
        class="mr-10"
        rounded
        outlined
        :disabled="!editingObject.evaluationId && !editingObject.id"
        @click="onDeleteItem"
      >Delete</v-btn>
      <v-btn color="primary" class="mr-0" rounded @click="onSave">Save</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import Fuse from 'fuse.js'

export default {
  name: "CreateEditEvaluation",

  data: () => ({
    isLoading: true,
    search: "",
    id: null,
    dialogConfirmDelete: false,
    editingObject: {},
    ingredient: {},
    restriction: {},
    prohibited: {},
    isEdit: false,
    isCreate: false,

    searchCosing: "",
    searchCosingItems: [],
    searchCosingLoading: false,

    cosingRefSuggestion: false,

    fuse: null,
    fuseOptions: {
      keys: ['inciName', 'casNumber']
    }
  }),

  created() {
    this.id = this.$route.params.id ? this.$route.params.id : null;
    this.resetEditingObject();
    this.init();

    this.fuse = new Fuse(this.cosing, this.fuseOptions)
  },

  watch: {
    activeProject: function () {
      //this.fetchProjectIngredient();
      if (this.isLoading) {
        this.init();
      }
    },
    searchCosing (val) {
      val && this.queryCosing(val)
    },
  },

  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
    company() {
      return this.$store.getters['company/getCompany']
    },
    cosing() {
      return this.$store.getters["ingredients/getCosing"];
    },
    activeProject() {
      return this.$store.getters["projects/getActiveProject"];
    },
    projectIngredients() {
      return this.$store.getters["projectIngredients/getProjectIngredients"];
    },
    cosingLink() {
      if (!this.editingObject.reference) return null;
      const url = " https://ec.europa.eu/growth/tools-databases/cosing/index.cfm?fuseaction=search.details_v2&id=";
      return url + '' + this.editingObject.reference;
    },
    cosingItem: {
      set(item) {
        this.ingredient = item;
        this.editingObject.reference = item.reference;
      },
      get() {
        return this.ingredient;
      }
    },
  },

  methods: {
    init() {
      if (this.id) {
        this.isLoading = true;
        if (this.activeProject && this.activeProject.id) {
          this.fetchProjectIngredient()
        }
      } else {
        this.isCreate = true;
        this.onCreateItem();
      }
    },
    resetEditingObject() {
      this.editingObject = {
        reference: "",
        inciName: "",
        innName: "",
        phEurName: "",
        casNumber: "",
        cosingRef: "",
        ecNumber: "",
        iupacName: "",
        function: "",
        restriction: "",
        evaluatedRestriction: "",
        updateDate: "",
        evaluationId: null,

        projectId: "",
        id: "",
        noael: "",
        assessment: "",
        dermalAbsorptionPcnt: "",
        clp: "",

        added: "",
        updated: "",
        custom: null,
      };
    },
    fetchProjectIngredient() {
      this.$store
        .dispatch("projectIngredients/fetchProjectIngredient", { 
          projectId: this.activeProject.id,
          itemId: this.id,
        })
        .then(() => {
          this.initEvaluationEditView(this.id);
        });
    },
    async initIngredient(ref) {
      if (ref && this.activeProject) {
        this.$store.dispatch('ingredients/fetchIngredient', { projectId: this.activeProject.id, reference: ref })
          .then((res) => {
            this.ingredient = res;
            //this.cosingItem = this.ingredient;
            this.searchCosingItems.push(this.cosingItem)
          })
      } 
      else {
        this.queryCosing(this.editingObject.inciName)
        this.cosingItem = this.searchCosingItems[0];
      }
    },
    queryCosing(search) {
      if (search && search.length >= 2) {
        const res = this.fuse.search(search).slice(0,6)
        this.searchCosingItems = res.map((obj) => { return obj.item });
      } else {
        this.searchCosingItems = [];
      }
    },
    initEvaluationEditView(id) {
      const item = this.$store.getters["projectIngredients/getProjectIngredient"](id);
      if (item) {
        this.onEditItem(item, 'evaluation');
        this.cosingRefSuggestion = item.reference ? false : true;
      } else {
        this.isLoading = false;
      }
    },
    isProhibited () {
      return this.$store.getters["ingredients/isProhibited"](this.editingObject);
    },
    isRestricted () {
      return this.$store.getters["ingredients/isRestricted"](this.editingObject);
    },
    getProjectIngredient(item) {
      return this.projectIngredients.find((obj) => {
        if (obj.reference === item.reference || obj.casNumber === item.casNumber || obj.inciName === item.inciName) {
          return obj;
        }
      });
    },
    onCreateItem() {
      if (this.activeProject && this.activeProject.id) {
        this.resetEditingObject();

        // check if route has copy
        if (this.$route.params.item) {
          this.editingObject = this.$route.params.item;
        }
        
        this.editingObject.projectId = this.activeProject.id;
        this.editingObject.companyId = this.company.id;
        this.editingObject.createdBy = this.user.id;
        this.editingObject.updatedBy = this.user.id;
        this.editingObject.custom = true;

        this.isLoading = false;

      }
    },
    onEditItem(item) {
      this.isEdit = true;
      this.editingObject = JSON.parse(JSON.stringify(item));

      this.editingObject.projectId = this.activeProject.id;
      this.editingObject.companyId = this.company.id;
      this.editingObject.updatedBy = this.user.id;

      this.initIngredient(this.editingObject.reference);

      this.isLoading = false;
    },
    onSave() {
      if (!this.activeProject) {
        this.$notify({
          group: "base",
          type: "error",
          title: "No active Workspace",
          text: "You need to select a Workspace",
        });
        return null;
      }
      if (this.isEdit) {
        this.editItem();
      } else {
        this.addItem();
      }
    },
    onDeleteItem() {
      this.dialogConfirmDelete = true;
    },
    addItem() {
      if (this.editingObject.projectId) {
        this.$store
          .dispatch(
            "projectIngredients/addProjectIngredient",
            JSON.parse(JSON.stringify(this.editingObject))
          )
          .then(() => {
            this.$notify({
              group: "base",
              type: "success",
              title: "Item created",
              text: "Evaluation of the ingredient has been successfully created",
            });
            this.$router.replace({ name: "evaluations" });
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              group: "base",
              type: "error",
              title: "Oops, something went wrong",
              text:
                "Evaluation of the ingredient has not been created. Please try again.",
            });
          });
      }
    },
    editItem() {
      if ( (this.editingObject.reference || this.editingObject.id) && this.editingObject.projectId) {
        this.$store
          .dispatch(
            "projectIngredients/editProjectIngredient",
            JSON.parse(JSON.stringify(this.editingObject))
          )
          .then(() => {
            this.$notify({
              group: "base",
              type: "success",
              title: "Item updated",
              text: "Evaluation of the ingredient has been successfully updated",
            });
            this.$router.replace({ name: "evaluations" });
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              group: "base",
              type: "error",
              title: "Oops, something went wrong",
              text: "Evaluation of the ingredient has not been updated. Please try again.",
            });
          });
      }
    },
    deleteItem() {
      if (this.editingObject.reference !== "" && this.editingObject.projectId) {
        this.$store
          .dispatch(
            "projectIngredients/deleteProjectIngredient",
            this.editingObject
          )
          .then(() => {
            this.dialogConfirmDelete = false;
            this.$router.replace({ name: "evaluations" });
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              group: "base",
              type: "error",
              title: "Oops, something went wrong",
              text: "The item has not been deleted. Please try again.",
            });
          });
      }
    },
    onIngredientLink(){
      this.$router.push({
        name: "ingredients.view",
        params: { id: this.cosingItem.reference },
      });
    }
  },
};
</script>

<style lang="sass">
.v-autocomplete.orange-label
  .v-label
      color: orange !important
</style>